var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"carTravel"}},[_vm._v("车载出行绩效分析")])
}
var staticRenderFns = []

export { render, staticRenderFns }